import React, { useEffect, useState, useContext } from "react";

export const Videos = (props) => {

    const video = "https://fwm.ferrettigroup.com/asset/fwm/upload/configurator/videos/infynito80/video.mp4";
    const posterImage = "https://fwm.ferrettigroup.com/asset/fwm/upload/configurator/videos/infynito80/poster.jpg";

    return (
        <>
            <div className="container" id="Videos">
                <div className="row vh-lg-100">
                    <div className="col-12" data-aos="zoom-in" data-aos-duration="1500">
                        <div className="row justify-content-center h-100">
                            <div className="col-12">
                                <div className="valign">
                                    <div className="align-middle d-table-cell">
                                        <div className="d-table mx-auto position-relative bkg-video">
                                            <h2 className="text-uppercase text-center text-white mb-3">Video</h2>
                                            <video className="video w-100" poster={posterImage} controls>
                                                <source src={video} type="video/mp4" />
                                            </video>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="pb-5" id="Fsea">
            </div>

        </>
    );




};

export default Videos;